import React, { useState, useEffect } from 'react';
import { getToken } from './SellerApi';
import SellerAuth from './SellerAuth';
import { SellerDashboard } from './SellerDashboard';
import { SellerOrders } from './SellerOrders';
import { SellerProfile } from './SellerProfile';
import { SellerWallet } from './SellerWallet';
import { SellerDeals } from './SellerDeals';
import { SellerReturns } from './SellerReturns';
import { SellerPolicies } from './SellerPolicies';
import './SellerPortal.css';

export default function MartSellerRoot() {
  const [isAuthenticated, setIsAuthenticated] = useState(!!getToken());
  const [currentView, setCurrentView] = useState('dashboard');
  const [sellerData, setSellerData] = useState(null);

useEffect(() => {
    if (isAuthenticated) {
      const storedUser = localStorage.getItem('seller_user');
      // Check both that it exists AND that it isn't the literal string "undefined"
      if (storedUser && storedUser !== "undefined") {
        try {
          setSellerData(JSON.parse(storedUser));
        } catch (err) {
          console.error("Failed to parse seller_user from localStorage:", err);
          // Fallback: Clear it out if it's corrupted
          localStorage.removeItem('seller_user');
          setSellerData(null);
        }
      }
    }
  }, [isAuthenticated]);

  useEffect(() => {
    const handleNav = (e) => setCurrentView(e.detail);
    document.addEventListener('sp-nav', handleNav);
    return () => document.removeEventListener('sp-nav', handleNav);
  }, []);

  const handleAuthSuccess = (token, user) => {
    localStorage.setItem('seller_token', token);
    localStorage.setItem('seller_user', JSON.stringify(user));
    setSellerData(user);
    setIsAuthenticated(true);
    setCurrentView('dashboard');
  };
  const handleLogout = () => {
    localStorage.removeItem('seller_token');
    localStorage.removeItem('seller_user');
    setIsAuthenticated(false);
  };
  if (!isAuthenticated) return <SellerAuth onAuthSuccess={handleAuthSuccess} />;
  return (
    <div className="sp-portal-layout">
      <aside className="sp-sidebar">
        <div className="sp-sidebar-brand">
          <h2>ATR <span>SELLER HUB</span></h2>
        </div>
        <nav className="sp-sidebar-menu">
          {[
            { id: 'dashboard', label: 'Dashboard', icon: '📊' },
            { id: 'orders', label: 'Orders Management', icon: '📦' },
            { id: 'deals', label: 'Offers & Deals', icon: '🏷️' },
            { id: 'returns', label: 'Return Requests', icon: '🔄' },
            { id: 'wallet', label: 'Payout Wallet', icon: '💳' },
            { id: 'profile', label: 'Store Profile', icon: '🏪' },
            { id: 'policies', label: 'Terms & Signing', icon: '📜' },
          ].map(item => (
            <button key={item.id} className={`sp-nav-item ${currentView === item.id ? 'active' : ''}`} onClick={() => setCurrentView(item.id)}>
              <span className="sp-nav-icon">{item.icon}</span>{item.label}
            </button>
          ))}
        </nav>
        <div className="sp-sidebar-footer">
          <button className="sp-logout-btn" onClick={handleLogout}>Logout</button>
        </div>
      </aside>
      <main className="sp-main-viewport">
        {currentView === 'dashboard' && <SellerDashboard seller={sellerData} />}
        {currentView === 'orders' && <SellerOrders />}
        {currentView === 'deals' && <SellerDeals />}
        {currentView === 'returns' && <SellerReturns />}
        {currentView === 'wallet' && <SellerWallet />}
        {currentView === 'profile' && <SellerProfile />}
        {currentView === 'policies' && <SellerPolicies />}
      </main>
    </div>
  );
}